import React from "react";
import { observer } from "mobx-react-lite";
import EventButton, {
  EventButtonVariant,
} from "../../shared/components/EventButton";
import SetupStore from "../store/setupStore";

interface UngeneratedSetupsProps {
  onStartNewRound: () => void;
  handleCreateManualSetups: () => void;
}

const UngeneratedSetups: React.FC<UngeneratedSetupsProps> = observer(
  ({ onStartNewRound, handleCreateManualSetups }) => (
    <div className="mb-8">
      <div className="bg-[#121212] backdrop-blur-sm rounded-lg p-6 text-center space-y-8">
        <div className="space-y-4">
          <h2 className="text-3xl font-nostalgic text-white leading-tight">
            You'll see all the setups for Round {SetupStore.activeRound} once
            you generate them.
          </h2>
          <p className="text-white/60 text-sm">
            (You can only generate setups within 30
            <br />
            minutes of the event start time)
          </p>
        </div>

        <div className="space-y-6">
          <EventButton
            onClick={onStartNewRound}
            variant={EventButtonVariant.PRIMARY_WHITE}
            className="w-full text-lg py-4"
            icon="❤️‍🔥"
          >
            Generate Round {SetupStore.activeRound} setups
          </EventButton>
        </div>
      </div>

      <div className="space-y-4">
        <p className="text-white text-base text-center mt-8">
          Have guests that you know belong together?
        </p>
        <EventButton
          onClick={() => handleCreateManualSetups()}
          variant={EventButtonVariant.TRANSPARENT}
          className="w-full text-lg py-3"
          icon="🤝"
        >
          Create manual setups
        </EventButton>
      </div>
    </div>
  ),
);

export default UngeneratedSetups;
